<template>
	<PageContainer>
		<AmeliproCard no-card-header>
			<Historique />
		</AmeliproCard>
	</PageContainer>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';
	import { Meta, MetaInfo } from '@/decorators';
	import Historique from '@/components/dpa/Historique.vue';

	@Component({
		components: {
			Historique
		}
	})
	export default class HistoriqueDpa extends Vue {
		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				title: 'PEGASE - Historique de vos Demandes de Paiement d’Astreintes (DPA) par journée' as string
			};
		}
	}
</script>
